<div class="dashboard-page custom-page">
  <app-data-table
    [addButtonText]="addButtonText | translate"
    title="{{ 'DashboardPage.Title' | translate }}"
    filterPlaceholder="{{ 'DashboardPage.FilterPlaceholder' | translate }}"
    (openModal)="openDashboard($event)"
    (openDashboards)="open($event)"
    (deleteRow)="deleteDashboard($event)"
    (exportLog)="exportDashboard($event)"
    [pageSize]="pageSize"
    [displayTitle]="displayTitle"
    [displayedColumnsName]="displayedColumnsName"
    [displayedColumns]="displayedColumns"
    [data]="dashboards"
    showDesigner="true"
    [actionButtonsList]="actionButtonsList"
  >
  </app-data-table>
</div>
